import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { FavoriteList, UpdateFavoriteListCommand,DeleteFavoriteListCommand, FavoriteListViewModel } from "Api/CoreApi";
import store from "Store/index"
import BaseComponent from 'Components/Base/ABaseComponent';

@Component({
    template: "#favorite-list-detail-template"
})
export default class FavoriteDetailComponent extends Mixins(BaseComponent) {
    @Prop()
    public detail: FavoriteListViewModel;


    public disabled : boolean = true;
    public newName: string = '';

    confirmDeleteElement: HTMLElement;
 
    async mounted(){
        this.newName = this.detail.name;

        this.confirmDeleteElement = document.getElementById('favoritelist_confirm_txt');
    }
    
    
    changeName(){
        this.disabled = !this.disabled;
        this.newName = this.detail.name;
    }
    
    
    async created(){
    }


    async updateName() {
        store.dispatch.favoriteList.updateFavoriteList(new UpdateFavoriteListCommand({
            id: this.detail.id,
            name: this.newName
        }));
        this.disabled = true;
        //Reset variables 
        this.newName = ""; 
    }
    
    async deleteList() {
        let message = this.confirmDeleteElement.innerHTML.replace('{0}',this.detail.name);
        if(confirm(message)){
            store.dispatch.favoriteList.deleteFavoriteList(new DeleteFavoriteListCommand({
                id:this.detail.id
            }));
        }
    }
}

Vue.component('favorite-list-detail', FavoriteDetailComponent);